// extracted by mini-css-extract-plugin
module.exports = {"comp":"AccessoriesA_comp__p0NgB"};